import { $axios } from '~/utils/api'

const USERS_ENDPOINT = '/zipcode'

const isValidZipcode = (zipcode: string): Promise<{ valid: boolean }> =>
  $axios.$get(`${USERS_ENDPOINT}/validate/${zipcode}`)

export { isValidZipcode }
